import { createPinia } from 'pinia';
import { AbortControllerPlugin } from '@centric-os/stores/plugins/abort-controller';
import { APIPlugin } from '@centric-os/stores/plugins/api';
import { PaginationPlugin } from '@centric-os/stores/plugins/pagination';
import { piniaResetDispose } from '@centric-os/stores/plugins/reset-dispose';
import { cdlApi, genericAPI } from './../api';
import PersiststatePlugin from 'pinia-plugin-persistedstate';

const pinia = createPinia();

pinia.use(APIPlugin({ cdlApi, genericAPI }));
pinia.use(AbortControllerPlugin());
pinia.use(piniaResetDispose);
pinia.use(PaginationPlugin());
pinia.use(PersiststatePlugin);

export default pinia;
